module.exports = __webpack_public_path__ + "img/p02.d1489a38.png";